import { newArchAxiosInstance } from "utils/request"
import {
  beginTransactionTracking,
  reconcileTransactionRequestError,
} from "features/process-monitor/transactionProgressClient"

const DOWNLOAD_PAYROLL_REPORT = "download payroll report"

export const downloadPayrollSummary = async (
  id: string,
  staffCategory?: string
) => {
  await beginTransactionTracking({
    id,
    type: DOWNLOAD_PAYROLL_REPORT,
    title: "Download Payroll Summary Report",
    message: "Preparing payroll report",
  })

  try {
    const response = await newArchAxiosInstance.get(
      "/admin/payrolls/view/report/summary/download",
      {
        params: { id, format: "excel", staffCategory },
        responseType: "blob",
      }
    )

    const disposition = response.headers["content-disposition"] as
      | string
      | undefined
    const fileName =
      disposition?.match(/filename\*?=(?:UTF-8''|\")?([^";]+)/i)?.[1] ||
      "payroll-summary.xlsx"
    const url = URL.createObjectURL(response.data)
    const link = document.createElement("a")
    link.href = url
    link.download = decodeURIComponent(fileName)
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(url)
  } catch (error) {
    await reconcileTransactionRequestError(
      DOWNLOAD_PAYROLL_REPORT,
      id,
      "Payroll report download failed"
    )
    throw error
  }
}
